const genderMap = {
  U: 'Unissex',
  M: 'Masculino',
  F: 'Feminino',
} as const

type GenderKey = keyof typeof genderMap

export function getGenderDescription<T extends GenderKey>(
  g: T
): typeof genderMap[T] {
  return genderMap[g]
}

// Examples:
// const a = getGenderDescription("U"); // "unissex"
// const b = getGenderDescription("M");
